import { Box, Button, Stack, Text } from "@mantine/core";

import { useDeleteCuratedSpaceMutation } from "../curation.queries.graphql.generated";

type DeleteCuratedSpaceModalProps = {
  curatedSpaceId: string;
  onClose: () => void;
};

export const DeleteCuratedSpaceModal = (
  props: DeleteCuratedSpaceModalProps
) => {
  const { curatedSpaceId, onClose } = props;

  const [deleteCuratedSpace, deleteCuratedSpaceMutationInfo] =
    useDeleteCuratedSpaceMutation();

  const handleOnSubmit = async () => {
    try {
      const result = await deleteCuratedSpace({
        variables: {
          deleteCuratedSpaceId: curatedSpaceId,
        },
      });

      console.log("Result", result);
      onClose();
    } catch (error) {
      console.error("Error deleting curated space", error);
    }
  };

  return (
    <Box>
      <Stack>
        <Text c={"dimmed"} size={"sm"}>
          Are you sure you want to delete this curated space? This action cannot
          be undone.
        </Text>

        <Button
          onClick={handleOnSubmit}
          loading={deleteCuratedSpaceMutationInfo.loading}
        >
          Delete
        </Button>
      </Stack>
    </Box>
  );
};
